import { render, staticRenderFns } from "./ServiceCreateEdit.vue?vue&type=template&id=b11fb7d0&scoped=true"
import script from "./ServiceCreateEdit.vue?vue&type=script&lang=js"
export * from "./ServiceCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceCreateEdit.vue?vue&type=style&index=0&id=b11fb7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11fb7d0",
  null
  
)

export default component.exports